import { FC } from 'react';
import ProLayout, { LayoutProps } from './layout';
import ProLayoutHeader, { LayoutHeaderProps } from './header';
import ProLayoutFooter, { LayoutFooterProps } from './footer';
import ProLayoutContent, { LayoutContentProps } from './content';
import ProLayoutSider, { LayoutSiderProps } from './sider';

export type ILayoutComponent = FC<
  LayoutProps & React.RefAttributes<HTMLElement>
> & {
  Header: FC<LayoutHeaderProps & React.RefAttributes<HTMLElement>>;
  Footer: FC<LayoutFooterProps & React.RefAttributes<HTMLElement>>;
  Content: FC<LayoutContentProps & React.RefAttributes<HTMLElement>>;
  Sider: FC<LayoutSiderProps & React.RefAttributes<HTMLElement>>;
};

const TransLayout = ProLayout as ILayoutComponent;
TransLayout.Header = ProLayoutHeader;
TransLayout.Footer = ProLayoutFooter;
TransLayout.Content = ProLayoutContent;
TransLayout.Sider = ProLayoutSider;

export default TransLayout;
